import { userLogin, userCodeLogin, userInfo, subAccountLogin } from "@/api/public";
import { getToken, setToken, removeToken } from "@/utils/auth";

let _fetchingUserInfo = false;

const state = {
	token: "",
	info: ''
}

const mutations = {
	SET_TOKEN: (state, token) => {
		state.token = token;
	},
	SET_INFO: (state, info) => {
		state.info = info
	},
}

const actions = {
	result({ commit }, { response }) {
		let {userinfo={}} = response.data
		commit('SET_TOKEN', userinfo.token)
		commit('SET_INFO', userinfo)
		setToken(userinfo.token)
	},
	// user login
	login({ dispatch }, { params, type='login' }) {
		removeToken()
		return new Promise((resolve, reject) => {
			let http = null
			if(type == 'login') {
				http = userLogin(params)
			} else if (type == 'subLogin') {
				http = subAccountLogin(params)
			} else {
				http = userCodeLogin(params)
			}
			http.then(response => {
				if(response.code == 1 && response.data) {
					dispatch('result', { response })
					resolve(response)
				}
				if(response.code == 0) {
					reject()
				}
			}).catch(error => {
				reject(error)
			})
		})
	},
	logout({commit, state}) {
		return new Promise((resolve) => {
            commit('SET_TOKEN', null)
			commit('SET_INFO', {})
			removeToken()
            resolve();
        });
	},
	getUserInfo({commit, state, dispatch}) {
		if (_fetchingUserInfo) {
			return Promise.resolve(state.info);
		}
		_fetchingUserInfo = true;
		return new Promise((resolve, reject) => {
			userInfo().then(response => {
				const { data } = response
				if(!data) {
					reject("Verification failed, please Login again.")
				}
				commit('SET_TOKEN', data.token)
				commit('SET_INFO', data)
				setToken(data.token)
				resolve(data)
			}).catch(error => {
				reject(error)
			}).finally(() => {
				_fetchingUserInfo = false;
			})
		})
	}
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
